// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3a95f56b","453":"fdeaf49a","667":"9aa63f71"}[chunkId] + ".chunk.js";
};